import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(<path d="M12 8V4l8 8-8 8v-4H4V8z" />, 'Forward');
